import { getFieldType } from 'app/utils/schema';
import { getFieldInfo } from 'app/models/entities/selectors/unionEntity';
import { CommonText, Text } from 'app/constants/schemas';

/**
 * Checks if `${name}` or `custom_${name}` field is a custom text and
 * returns its description
 * @deprecated this should be replaced with unionEntity instead of adding any functionality.
 */
export function customText(entity, name) {
  return getPossiblyPrefixedFieldInfo(entity, name, 'custom', Text);
}

/**
 * Checks if `${name}` or `common_${name}` field is a common text and
 * returns its description
 * @deprecated this should be replaced with unionEntity instead of adding any functionality.
 */
export function commonText(entity, name) {
  return getPossiblyPrefixedFieldInfo(entity, name, 'common', CommonText);
}

function getPossiblyPrefixedFieldInfo(entity, fieldName, fieldPrefix, desiredType) {
  const fieldType = getFieldType(entity, fieldName);
  const prefixedFieldName = `${fieldPrefix}${fieldName.replace(/^[a-z]/, (l) => l.toUpperCase())}`;
  const prefixedFieldType = getFieldType(entity, prefixedFieldName);

  const finalFieldName = fieldType === desiredType ? fieldName :
                         prefixedFieldType === desiredType ? prefixedFieldName : null;

  return getFieldInfo(entity, finalFieldName);
}
